import React from 'react';
import { Box, Typography, FormControl, Card, MenuItem, Select, Divider } from '@mui/material';
import { getApolloScreeners, setApolloScreenersStatus } from '../../api';
import useFetch from '../../hooks/useFetch';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Checkbox from '@mui/material/Checkbox';

const TextWithLineBreaks = ({ text }) => {
    return (
      <div>
        {text.split('<LB>').map((part, index) => (
          <React.Fragment key={index}>
            {part}
            {index !== text.split('<LB>').length - 1 && <br />}
          </React.Fragment>
        ))}
      </div>
    );
  };

const isMoreNYearOld = (dateString, year) => {
    const inputDate = new Date(dateString);
    const today = new Date();
  
    // Set one year ago
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(today.getFullYear() - year);
  
    return inputDate < oneYearAgo;
};

const isMoreNMonthOld = (dateString, month) => {
    const inputDate = new Date(dateString);

    const currentDate = new Date();
    const nextMonthDate = new Date(currentDate);
    nextMonthDate.setMonth(currentDate.getMonth() - month);
  
    return inputDate < nextMonthDate;
};

const CoralScreeners = ({ patientId, username, token }) => {
    const { data: patient, loading, error } = useFetch(getApolloScreeners, patientId, { username, token });
    const [screeners, setScreeners] = React.useState([]);

    React.useEffect(() => {
        if (patient && patient.Screeners) {
            setScreeners(patient.Screeners);
        }
    }, [patient]);

    if (loading) return <Typography>Loading...</Typography>;
    if (error) return <Typography>Error: {error.message}</Typography>;

    if (patient.Active === 0) {
        return (<div></div>)
    }

    let screenersComponent = ""

    let screeningInfo = ""

    let hasInfo = 0
    if (patient.Active / 10 >= 1) {
        hasInfo = 1
        screenersComponent = (<div><Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            bgcolor="#b8503a"
            color="white"
            p={1}
            borderRadius="4px 4px 0 0"
        >
            Most Recent Screener Status
        </Box>
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableBody>
                    {screeners.map(sc => {
                        if (sc.Screener == 'Lipid Panel External' || sc.Screener == 'Retinopathy') {
                            return (<></>)
                        }
                        
                        const screenerThresholds = {
                            'AWV': 12,
                            'LAB-CBC': 12,
                            'LAB-CMP': 12,
                            'LAB-LIPID': 12,
                            'LAB-HGBA1C': 12,
                            'EKG': 12,
                            'MiniCog': 12,
                            'PHQ9': 12,
                            'Fall Efficacy': 12,
                            'AAFP-Home': 12,
                            'AAFP-Food': 12,
                            'Quantaflow': 24
                          };

                        let message = (<></>)
                        let action = (<></>)
                        const threshold = screenerThresholds[sc.Screener];
                        if (sc.LatestStatus === "Missing") {
                            action = (
                                <>
                                  <Typography component="span" sx={{ color: "#FF8C00", fontWeight: "bold" }}>
                                    missing
                                  </Typography>
                                </>
                              );
                        } else if (sc.LatestStatus === "Completed") {
                            if (threshold && isMoreNMonthOld(sc.LastStatusDate, threshold)) {
                                action = <Typography component="span" sx={{ color: "#FF8C00", fontWeight: "bold" }}>overdue</Typography>;
                            } 
                            else if (threshold && isMoreNMonthOld(sc.LastStatusDate, threshold - 1)) {
                                action = <Typography component="span" sx={{ color: "#AA44AA", fontWeight: "bold" }}>due soon</Typography>;
                            }
                        
                            message = (
                                <>
                                  <Typography component="span" sx={{ color: "#888888", fontWeight: "bold" }}>
                                    {sc.LastStatusDate}
                                  </Typography>
                                </>
                            );
                        } else {
                            action = <Typography component="span" sx={{ color: "#FF8C00", fontWeight: "bold" }}>{sc.LatestStatus.toLowerCase()}</Typography>;
                            message = (
                                <>
                                  <Typography component="span" sx={{ color: "#FF8C00", fontWeight: "bold" }}>
                                    {sc.LastStatusDate}
                                  </Typography>
                                </>
                            );
                        }
                        return (
                            <TableRow key={sc.Screener} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell sx={{ padding: '4px', width: '150px' }} component="th" scope="row">
                                    {sc.Screener}
                                </TableCell>
                                <TableCell sx={{ padding: '4px' }} component="th" scope="row">
                                    {action}
                                </TableCell>
                                <TableCell sx={{ padding: '4px' }} align="right">
                                    {message}
                                </TableCell>
                            </TableRow>
                        )
                    }
                )}
                </TableBody>
            </Table>
        </TableContainer>
        </div>)
    }

    if (hasInfo === 0) {
        return (<></>)
    }
    return (
        <div>
            <Accordion defaultExpanded>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{ backgroundColor: '#d5dbdb', margin: '0 !important', minHeight: 'unset !important', '& .MuiAccordionSummary-content': { margin: '5px 0 !important' } }}
                >
                    <Typography variant="h6">Screeners</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ backgroundColor: '#eaeded', padding: '12px' }}>
                    {screenersComponent}
                </AccordionDetails>
            </Accordion>
            <Divider sx={{ height: 15 }} />
        </div>
    );
}

export default CoralScreeners;
